var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("ubl-to-purchase")))]),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-card-content" } },
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("app-file-upload", {
                    attrs: { label: _vm.$ct("ubl-file"), "max-size": 50e6 },
                    on: {
                      input: function ($event) {
                        _vm.file = $event
                      },
                    },
                  }),
                ],
                1
              ),
              _vm.file
                ? _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c(
                        "w-link",
                        {
                          on: {
                            click: function ($event) {
                              _vm.file = null
                            },
                          },
                        },
                        [
                          _c("w-fa", { attrs: { icon: "times" } }),
                          _vm._v(" " + _vm._s(_vm.file.name)),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: {
                icon: "check",
                disabled: !_vm.isValid || _vm.isSubmitting,
              },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.confirm")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }